import {createContext} from 'react';
import * as sdk from 'matrix-js-sdk';

type MatrixContextType = {
  matrixClient: sdk.MatrixClient | null;
  matrixUserId: string | null;
  unreadTotal: number;
  rooms: sdk.Room[] | null;
  handleStopMatrixClient: () => Promise<void>;
  startMatrixLoginProcess: () => Promise<void>;
};

const defaultContext: MatrixContextType = {
  matrixClient: null,
  matrixUserId: null,
  unreadTotal: 0,
  rooms: null,
  handleStopMatrixClient: async () => {
    //
  },
  startMatrixLoginProcess: async () => {
    //
  }
};

const MatrixContext = createContext<MatrixContextType>(defaultContext);

export default MatrixContext;
